import EditIcon from '@mui/icons-material/Edit';
import { IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { useMemo } from "react";
import { tableConfig } from "../../../commons/table/tableConfig";
import { StyledResolucion } from "../../../styled/Prevencion";

const ExamenesMedicosTable = ({ data, handleOpenExamenesMedicos, sustancias, values }) => {

  const columns = useMemo(() => [
    {
      accessorKey: "nombreAgente",
      header: "Código Sustancia",
      Cell: ({ row }) => sustancias.find((s) => s.id === row.original.id)?.sustancia?.nombreAgente,
      filterVariant: 'text',
      minSize: 150,
      maxSize: 250,
      size: 200,
    },
    {
      accessorKey: "descripcionAgente",
      header: "Descripción Sustancia",
      Cell: ({ row }) => sustancias.find((s) => s.id === row.original.id)?.sustancia?.descripcionAgente,
      filterVariant: 'text',
      minSize: 200,
      maxSize: 400,
      size: 300,
    },
  ], [sustancias]);

  const table = useMaterialReactTable({
    columns,
    data: data || [],
    enableRowActions: true,
    positionActionsColumn: "last",
    displayColumnDefOptions: {
      "mrt-row-actions": {
        header: "Operaciones",
        size: 120,
        muiTableHeadCellProps: {
          sx: {
            ...tableConfig.muiTableHeadCellProps?.sx,
            justifyContent: 'center',
          },
        }
      },
    },
    enableHiding: false,
    paginationDisplayMode: 'pages',
    initialState: {
      pagination: {
        pageSize: 5,
        pageIndex: 0,
      },
    },
    muiPaginationProps: {
      rowsPerPageOptions: [5, 10, 20],
      labelRowsPerPage: "Filas por página:",
      getItemAriaLabel: (type) => {
        if (type === 'first') return 'ir a la primera página';
        if (type === 'last') return 'ir a la última página';
        if (type === 'next') return 'ir a la página siguiente';
        return 'ir a la página anterior';
      },
      labelDisplayedRows: ({ from, to, count }) => `${from}-${to} de ${count}`,
    },
    localization: {
      ...MRT_Localization_ES,
      noRecordsToDisplay: "No hay datos que mostrar",
    },
    renderTopToolbarCustomActions: () => (
      <StyledResolucion.HeaderContainer>
        <StyledResolucion.TableTitle>
          Exámenes Médicos
        </StyledResolucion.TableTitle>
      </StyledResolucion.HeaderContainer>
    ),
    renderRowActions: ({ row }) => (
      <Tooltip title="Editar Trabajador">
        <IconButton
          onClick={() => handleOpenExamenesMedicos(row.original, values)}
          color="primary"
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    ),
    enablePagination: true,
    enableColumnFilters: true,
    enableFilters: true,
    enableColumnActions: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    muiTableHeadCellProps: {
      sx: { ...tableConfig.muiTableHeadCellProps?.sx }
    },
    muiTableBodyRowProps: {
      sx: { ...tableConfig.muiTableBodyRowProps?.sx }
    },
    muiFilterTextFieldProps: {
      placeholder: 'Filtrar...',
      size: 'small',
      variant: 'outlined',
    },
  });

  return (
    <StyledResolucion.TableContainer>
      <MaterialReactTable table={table} />
    </StyledResolucion.TableContainer>
  );
};

export default ExamenesMedicosTable;